export default "__VITE_ASSET__9a9c3891__"